<!-- <div class="disease-wrapper">
  <div class="container">
    <div class="title-wrapper">
      <h4 class="lbl">{{'HEADER.remedies' | translate}}</h4>
      <button [routerLink]="['/diseaselist']">{{'HEADER.Viewall' | translate}}</button>
    </div>
    <div class="slider">
      <ngx-slick-carousel
        class="carousel"
        #slickModal="slick-carousel"
        [config]="slideConfig">
      <div class="mlr-10" *ngFor="let disease of disease">
        <div ngxSlickItem  class="slide">
          <div class="card">
            <img class="card-img-top" [src]="disease?.image" alt="Card image cap" />
            <div class="card-body">
              <h5 class="card-title" *ngIf="currentLang == 'en'">{{disease?.nameEng}}</h5>
              <h5 class="card-title" *ngIf="currentLang == 'hi'">{{disease?.nameHin}}</h5>
              <h5 class="card-title" *ngIf="currentLang == 'mr'">{{disease?.nameMar}}</h5>
              <p class="card-text mb-4">
              <span *ngIf="currentLang == 'en'">  {{disease?.short_Desc_ENG | slice:0:50 }}...</span>
              <span *ngIf="currentLang == 'hi'">  {{disease?.short_Desc_HIN | slice:0:50 }}...</span>
              <span *ngIf="currentLang == 'mr'">  {{disease?.short_Desc_MAR | slice:0:50 }}...</span>
              </p>
                <button class="btnbox" [routerLink]="['/disease-detail',disease.nameEng,disease.id]">
                  {{'DETAILS.Viewdetail' | translate}}
                </button>
            </div>
          </div>
        </div>
      </div>
      </ngx-slick-carousel>
    </div>
  </div>
</div>
<br> --> 
<div class="about-section">
  <div class="container">
    <div class="row align-items-center m-1">
      <!-- Left Side: Text -->
      <div class="col-md-7 col-12 about-text">
        <h2>Unlock Your Child's Innate Potential : Nurturing Holistic Growth for a Brighter Future</h2>
        <h3>Building a Lifestyle of Discipline, Creativity & Joy Through Co-Curricular Skills</h3>
        <p>
          At Innovative Vision, we believe every child holds a universe of potential within. Our mission, since 2020, has been to provide a structured, empathetic environment where children can explore, discover, and develop their true selves through engaging sports and co-curricular programs. We focus on fostering the vital right-brain development, essential for creativity,   intuition, and emotional intelligence , ensuring a balanced and enriching journey for  child.
        </p>
         <div class="frame-3_1-876">
      <span class="text-explore-programs_1-877" routerLink="/program">Explore Programs</span>
    </div>
      </div>
      <!-- Right Side: Image -->
      <div class="col-md-5 col-12 text-center about-img">
        <img src="assets/ivimg/homeH.svg" alt="Girl Learning Pottery" class="img-fluid">
      </div>
    </div>
  </div>
</div>
<div class="why-innovative-section">
  <!-- Image -->
  <div class="image-container">
    <img src="assets/ivimg/whyVision.svg" alt="Innovative Vision"/>
  </div>
  <!-- Text Content -->
  <div class="text-container">
    <div class="heading-block">
      <h2>Why Innovative Vision?</h2>
      <h3>Beyond Skills: Our Commitment to Your Child's Complete Well-being</h3>
    </div>
    <p>
      <strong>Unlocking Potential, Not Just Creating Stars:</strong> We don't promise to make  child a star, but we do promise to provide a nurturing space where their unique potential is identified and cultivated. Our focus is on building a foundation for a healthy, active, and joyful lifestyle.
    </p>
    <p>
      <strong>Right Brain Development for a Balanced Future:</strong>  Our meticulously designed activity-based learning programs in sports, yoga, and gymnastics specifically target and enhance right-brain functions crucial for creativity, problem-solving, and emotional intelligence  ensuring a truly holistic development.
    </p>
    <p>
      <strong>Structured & Organized Learning:</strong> As one of the first company to identify the need for an organized approach to co-curricular skills, our programs are progressive, outcome-based, and include periodic assessments to monitor  child's development. Our certified coaches are passionate mentors to nurture talent.
    </p>
    <p>
      <strong>Aligned with National Educational Policy (NEP) 2020:</strong> Our approach to inculcating essential skills such as gross motor skills, discipline, communication skills, and team spirit finds direct mention and emphasis in the NEP 2020, ensuring our programs are contemporary and impactful.
    </p>
  </div>
</div>
